import { call, takeEvery } from 'redux-saga/effects';
import * as apis from '../../network/apis/services';
import * as types from './types';
import { showErrorMsg, showSuccessMsg } from '../../utils/Helpers';

function* createServiceRequestSaga({ payload, onSucess }) {
  try {
    yield call(apis.addService, payload);
    onSucess();
    yield showSuccessMsg('addedSuccessfully');
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
};

function* updateServiceRequestSaga({ payload, onSucess }) {
  try {
    yield call(apis.editService, payload);
    onSucess();
    yield showSuccessMsg('editedSuccessfully');
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
};

function* deleteServiceRequestSaga({ payload, onSucess }) {
  try {
    yield call(apis.deleteService, payload);
    onSucess();
    yield showSuccessMsg('deletedSuccessfully');
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
};

export default function* ServicesSagas() {
  yield takeEvery(types.CREATE_SERVICE_REQUEST, createServiceRequestSaga);
  yield takeEvery(types.UPDATE_SERVICE_REQUEST, updateServiceRequestSaga);
  yield takeEvery(types.DELETE_SERVICE_REQUEST, deleteServiceRequestSaga);
}
